import Review from './models/review';
import Schema from './models/schema';

const exported = {
  Schema,
  Review,
};

export default exported;
export { Schema, Review };
